module.exports = __webpack_public_path__ + "static/media/bnr12.04834a18.jpg";